function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["rewardChoiceId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Spin } from '@nackle/paper';
import RecognitionService from '../../services/recognition';
import CMXService from '../../services/cmx';

var RewardChoiceLabel = /*#__PURE__*/function (_React$Component) {
  _inherits(RewardChoiceLabel, _React$Component);

  var _super = _createSuper(RewardChoiceLabel);

  function RewardChoiceLabel() {
    var _this;

    _classCallCheck(this, RewardChoiceLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false,
      rewardChoices: []
    });

    _defineProperty(_assertThisInitialized(_this), "loadRewardChoices", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var auth, recognitionService, rewardChoices, cmxService, strings, stringsMap, rewardChoiceOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              auth = _this.props.auth;

              _this.setState({
                loading: true
              });

              _context.prev = 2;
              recognitionService = new RecognitionService(auth.state);
              _context.next = 6;
              return recognitionService.searchRewardChoices();

            case 6:
              rewardChoices = _context.sent;
              cmxService = new CMXService(auth.state);
              _context.next = 10;
              return cmxService.getStringsWithAttributes('recognition', 'en-US', [{
                name: 'rewardChoice.name',
                attributes: {
                  rewardChoiceId: rewardChoices.map(function (rc) {
                    return rc.id;
                  })
                }
              }]);

            case 10:
              strings = _context.sent;
              stringsMap = {};

              if (Array.isArray(strings['rewardChoice.name'])) {
                strings['rewardChoice.name'].forEach(function (s) {
                  stringsMap[s.stringAttributes.rewardChoiceId] = s;
                });
              }

              rewardChoiceOptions = [];
              rewardChoices.forEach(function (rc) {
                if (stringsMap[rc.id]) {
                  rewardChoiceOptions.push({
                    id: rc.id,
                    name: stringsMap[rc.id].value
                  });
                }
              });
              rewardChoiceOptions = rewardChoiceOptions.sort(function (a, b) {
                return a.name.localeCompare(b.name, undefined, {
                  'sensitivity': 'base'
                });
              });

              _this.setState({
                rewardChoices: rewardChoiceOptions,
                loading: false
              });

              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

              _this.setState({
                loading: false
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 19]]);
    })));

    return _this;
  }

  _createClass(RewardChoiceLabel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadRewardChoices();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rewardChoiceId = _this$props.rewardChoiceId,
          props = _objectWithoutProperties(_this$props, _excluded);

      var _this$state = this.state,
          loading = _this$state.loading,
          rewardChoices = _this$state.rewardChoices;
      props.auth = undefined;
      var rewardChoice = rewardChoices.find(function (rc) {
        return rc.id === rewardChoiceId;
      });
      return /*#__PURE__*/React.createElement("span", props, rewardChoiceId && rewardChoice ? /*#__PURE__*/React.createElement("span", null, rewardChoice.name) : loading ? /*#__PURE__*/React.createElement(Spin, {
        size: "small"
      }) : /*#__PURE__*/React.createElement("span", null));
    }
  }]);

  return RewardChoiceLabel;
}(React.Component);

export { RewardChoiceLabel as default };
//# sourceMappingURL=reward-choice-label.js.map